import React, { createContext, type ReactNode, useRef, useState } from 'react';

export type AppLayoutContextType = {
  sidebarIsOpen: boolean;
  sidebarIsFixed: boolean;
  mobileMenuIsOpen: boolean;
  scrollRef: React.RefObject<HTMLDivElement | null> | null;
  setSidebarIsOpen: (value: boolean | ((prevVar: boolean) => boolean)) => void;
  setSidebarIsFixed: (value: boolean | ((prevVar: boolean) => boolean)) => void;
  setMobileMenuIsOpen: (value: boolean) => void;
};

export const AppLayoutContext = createContext<AppLayoutContextType>({
  sidebarIsOpen: false,
  sidebarIsFixed: false,
  mobileMenuIsOpen: false,
  scrollRef: null,
  setSidebarIsFixed: () => {
    return;
  },
  setSidebarIsOpen: () => {
    return;
  },
  setMobileMenuIsOpen: () => {
    return;
  },
});

export const AppLayoutContextProvider = ({ children }: { children: ReactNode }) => {
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const [sidebarIsOpen, setSidebarIsOpen] = useState(false);
  const [sidebarIsFixed, setSidebarIsFixed] = useState(false);
  const [mobileMenuIsOpen, setMobileMenuIsOpen] = useState(false);

  return (
    <AppLayoutContext.Provider
      value={{
        sidebarIsFixed,
        sidebarIsOpen,
        setSidebarIsOpen,
        setSidebarIsFixed,
        mobileMenuIsOpen,
        setMobileMenuIsOpen,
        scrollRef,
      }}
    >
      {children}
    </AppLayoutContext.Provider>
  );
};
